import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate,
  useLocation
} from "react-router-dom";

import apiClient from "../../../shared/API/apiClient";
import { useReportingYear } from "../../../context/ReportingYearContext";
export default function SubmittedResponses() {

  // =====================================
  // PARAMS
  // =====================================

  const {
    principleCode,
    legalEntityId,
    reportingYearId
  } = useParams();
const navigate =
  useNavigate();

const location =
  useLocation();

const entityName =
    location.state?.entityName;

  const {
    reportingYear
  } = useReportingYear();

  // =====================================
  // STATES
  // =====================================

  const [loading, setLoading] =
    useState(true);

  const [data, setData] =
    useState([]);

  // =====================================
  // FETCH
  // =====================================

  useEffect(() => {

    if (
      !principleCode ||
      !legalEntityId ||
      !reportingYearId
    ) {

      setLoading(false);

      return;
    }

    fetchResponses();

  }, [
    principleCode,
    legalEntityId,
    reportingYearId
  ]);

  // =====================================
  // API
  // =====================================

  const fetchResponses = async () => {

    try {

      setLoading(true);

      const url =
        `/api/principles/responses/${principleCode}?legal_entity_id=${legalEntityId}&reporting_year_id=${reportingYearId}`;

      const apiResponse =
        await apiClient.get(url);

      setData(
        apiResponse?.data?.responses || []
      );

    } catch (err) {

      console.error(
        "Failed to fetch responses",
        err
      );

      setData([]);

    } finally {

      setLoading(false);
    }
  };

  // =====================================
  // FORMAT
  // =====================================

  const formatValue=(value)=>{

  if(
    value===null ||
    value===undefined ||
    value===""
  ){

    return "--";
  }
  
// =====================================
  // DATE FORMAT
  // YYYY-MM-DD -> DD-MM-YYYY
  // =====================================

  if(
    typeof value==="string" &&
    /^\d{4}-\d{2}-\d{2}$/.test(value)
  ){

    const [year,month,day]=
      value.split("-");

    return `${day}-${month}-${year}`;
  }
  return value;
};

  // =====================================
  // EVIDENCE
  // =====================================

  const renderEvidence = (
    evidence = []
  ) => {

    if (!evidence.length) {
      return null;
    }

    return (

      <div className="sr-attachments">

        <div className="sr-attachment-title">
          📎 Attachments
        </div>

        {
          evidence.map(
            (file, index) => (

              <a
                key={index}
                href={file.file_url}
                target="_blank"
                rel="noreferrer"
                className="sr-attachment-link"
              >

                {file.file_name}

              </a>

            )
          )
        }

      </div>

    );
  };

  // =====================================
  // SINGLE
  // =====================================

  const renderSingle = (
    question
  ) => {

    if (
      question.data_type ===
      "boolean"
    ) {

      return (

        <div className="sr-boolean">

          {
            question.value == 1
              ? "Yes"
              : "No"
          }

        </div>

      );
    }

    return (

      <div className="sr-text">

        {
          formatValue(
            question.value
          )
        }

      </div>

    );
  };

  // =====================================
  // GROUPED
  // =====================================

  const renderGrouped = (
    question
  ) => {

    const details =
      Array.isArray(
        question.response_details
      )
        ? question.response_details[0] || {}
        : question.response_details || {};

    const fields =
      question.ui_schema
        ?.fields || [];

    return (

      <>
        <div className="sr-grid">

          {
            fields.map((field) => {

              let value =
                details[field.key];

              // FALLBACK

              if (
                value === undefined
              ) {

                const matchedKey =
                  Object.keys(details)
                    .find((k) =>
                      k.includes(
                        field.key
                      )
                    );

                value =
                  details[matchedKey];
              }
              if (field.options?.length) {

                const selectedOption =
                  field.options.find(
                    (o) =>
                      String(o.value) === String(value)
                  );

                if (selectedOption) {
                  value = selectedOption.label;
                }

              }

              return (

                <div
                  key={field.key}
                  className="sr-box"
                >

                  <label>
                    {field.label}
                  </label>

                  <div className="sr-text">

                    {
                      formatValue(
                        value
                      )
                    }

                  </div>

                </div>

              );
            })
          }

        </div>

        {
  question.system_value && (

    <div className="sr-result">

      <span>

        {
          question.ui_schema
            ?.derived
            ?.label ||

          question.ui_schema
            ?.summary
            ?.label ||

          "Summary"
        }

      </span>

     <strong>

  {
    Number(
      question.system_value
    ).toLocaleString(
      "en-IN",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    )
  }

  {
    question.data_type ===
      "percentage" ||

    question.question_text
      ?.includes("%") ||

    question.ui_schema
      ?.derived
      ?.label
      ?.includes("%")

      ? "%"

      : ""
  }

</strong>
    </div>

  )
}
      </>

    );
  };

// =====================================
// DERIVED
// =====================================

const renderDerived = (question) => {

  const details =
    Array.isArray(question.response_details)
      ? question.response_details[0] || {}
      : question.response_details || {};

  // =====================================
  // AUTO SUMMARY QUESTIONS
  // =====================================

 if (question.ui_schema?.type === "auto_summary") {

  const rows =
    question.ui_schema?.rows || [];

  return (

    <>
      <div className="sr-table-wrapper">

        <table className="sr-table">

          <thead>

            <tr>
              <th>Parameter</th>
              <th>Current FY</th>
            </tr>

          </thead>

          <tbody>

            {rows.map((row, index) => {

              if (row.type === "section") {

                return (

                  <tr
                    key={index}
                    className="sr-section-row"
                  >

                    <td colSpan="2">
                      <strong>
                        {row.label}
                      </strong>
                    </td>

                  </tr>

                );
              }

              const value =
                row.source_key
                  ? details?.[row.source_key]
                  : details?.[row.field_key];

              return (

                <tr
                  key={
                    row.source_key ||
                    row.field_key ||
                    index
                  }
                >

                  <td>
                    {row.label}
                  </td>

                  <td>

                    {formatValue(value)}

                    {row.unit
                      ? ` ${row.unit}`
                      : ""}

                  </td>

                </tr>

              );

            })}

          </tbody>

        </table>

      </div>

      {question.system_value && (

        <div className="sr-result">

          <span>
            Summary
          </span>

          <strong>

            {Number(
              question.system_value
            ).toLocaleString(
              "en-IN",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            )}

          </strong>

        </div>

      )}

    </>

  );
}

  // =====================================
  // EXISTING DERIVED LOGIC
  // =====================================

  const fields =
    question.ui_schema?.fields || [];

  const isAggregationDerived =
    question.ui_schema?.aggregation === true;

  return (

    <>
      {!isAggregationDerived && (

        <div className="sr-grid">

          {fields.map((field) => {

            let value = "--";

            if (
              details &&
              Object.keys(details).length > 0
            ) {

              value =
                details[field.key];

              if (
                value === undefined
              ) {

                const matchedKey =
                  Object.keys(details)
                    .find((k) =>
                      k.includes(field.key)
                    );

                value =
                  details[matchedKey];
              }
            }

            if (
              (
                value === undefined ||
                value === null ||
                value === "--"
              ) &&
              field.source_question_code
            ) {

              const sourceQuestion =
                data.find(
                  (q) =>
                    q.question_code ===
                    field.source_question_code
                );

              value =
                sourceQuestion?.system_value ||
                sourceQuestion?.value;
            }

            return (

              <div
                key={field.key}
                className="sr-box"
              >

                <label>
                  {field.label}
                </label>

                <div className="sr-text">
                  {formatValue(value)}
                </div>

              </div>

            );

          })}

        </div>

      )}

      <div className="sr-result">

        <span>

          {
            question.ui_schema?.display?.result_label ||

            question.ui_schema?.result?.label ||

            "Calculated Result"
          }

        </span>

        <strong>

          {question.system_value
            ? Number(
                question.system_value
              ).toLocaleString(
                "en-IN",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              )
            : "--"}

        </strong>

      </div>

    </>

  );
};


  // =====================================
  // TABLE
  // =====================================

  const renderTable = (
  question) => {
              const rows = question.response_details || [];

              const tableMeta = question.table_meta || {};

              const schemaRows = question.ui_schema?.rows || [];

              const columns = question.ui_schema?.columns || [];
              const schemaFields =
              schemaRows.filter(
                row => row.field_key
              );
            const beforeTableFields =
              schemaFields.filter(
                field =>
                  field.position === "before_table"
              );

            const afterTableFields =
              schemaFields.filter(
                field =>
                  field.position === "after_table"
              );
              let displayRows = [];

              // =====================================
              // FIXED ROW TABLES
              // Q13, Q14, Q15-B
              // =====================================

              if (
                question.ui_schema?.fixed_rows &&
                schemaRows.length > 0
              ) {

                schemaRows.forEach((schemaRow) => {

                 if (schemaRow.type === "section") {

                    displayRows.push(schemaRow);

                    return;
                  }

                  if (schemaRow.field_key) {
                    return;
                  }

                  const identifierKey =
                Object.keys(schemaRow).find((k) =>![
                  "type",
                  "label",
                  "readonly_row",
                  "field_key"
                ].includes(k)
                  );
                    if (!identifierKey) {
                    return;
                  }

          const responseRow =
            rows.find(
              (r) =>
                identifierKey &&
                r[identifierKey] ===
                schemaRow[identifierKey]
            );

                  displayRows.push(
                    responseRow || schemaRow
                  );

                });

    }

// =====================================
// DYNAMIC TABLES
// Q15-A and others
// =====================================

else {

  displayRows = rows;

}

const isStacked =
  question.ui_schema?.layout === "stacked";

  if (
  !rows.length &&
  !Object.keys(tableMeta).length
) {

  return (
    <p className="no-data">
      No data available
    </p>
  );

}
if (isStacked) {

return (
<div className="ecf-stacked-table">

  {rows.map((row, rowIndex) => (

    <div
      key={rowIndex}
      className="ecf-stacked-card"
    >

      {columns.map((column) => {

        let value = row[column.key];

            // Radio / Select / Boolean label conversion

            if (column.options?.length) {

              const option =
                column.options.find(
                  o =>
                    String(o.value) ===
                    String(value)
                );

              if (option) {
                value = option.label;
              }
            }

        return (

          <div
  key={column.key}
  className={`
    ecf-stacked-field
    ${
      question.ui_schema?.grid_columns
        ? `ecf-stacked-field-${question.ui_schema.grid_columns}`
        : ""
    }
    ${
      column.full_width
        ? "ecf-stacked-field-full"
        : ""
    }
  `}
>

            <label>
              {column.label}
            </label>

            <div className="sr-text">
              {formatValue(value)}
            </div>

          </div>

        );

      })}

    </div>

  ))}

</div>

);

}

  return (

    <>
{beforeTableFields.map((field) => (

  <div
    key={field.field_key}
    className="sr-box"
    style={{ marginBottom: "20px" }}
  >

    <label>
      {field.label}
    </label>

    <div className="sr-text">
      {formatValue(
        tableMeta?.[field.field_key]
      )}
    </div>

  </div>

))}
  <div className="sr-table-wrapper">

        <table className="sr-table">

          <thead>

            <tr>

              {
                columns.map(
                  (column) => (

                    <th key={column.key}>
                      {column.label}
                    </th>

                  )
                )
              }

            </tr>

          </thead>

          <tbody>

            {
              displayRows.map(
                            (
                              row,
                              rowIndex
                            ) => {

                              if (row.type === "section") {

                                return (

                                  <tr
                                    key={`section-${rowIndex}`}
                                    className="ecf-section-row"
                                  >

                                    <td
                                      colSpan={columns.length}
                                    >

                                      <strong>
                                        {row.label}
                                      </strong>

                                    </td>

                                  </tr>

                                );

                              }

                              return (

                                <tr key={rowIndex}
                              className={
                                row.readonly_row
                                  ? "ecf-title"
                                  : ""
                              }>

                   {
              columns.map(
                (column) => {

                  let value =
                    row[column.key];

                  // =====================================
                  // SMART FALLBACKS
                  // =====================================

                  if (
                    value === undefined
                  ) {

                    // program_name -> program
                    // assessed_projects -> projects_assessed
                    // directors -> directors_complaints

                    const normalizedColumn =
                      column.key
                        .toLowerCase()
                        .replace(/_/g, "");

                    const matchedKey =
                      Object.keys(row)
                        .find((k) => {

                          const normalizedKey =
                            k
                              .toLowerCase()
                              .replace(/_/g, "");

                          return (

                            normalizedKey ===
                              normalizedColumn ||

                            normalizedKey.includes(
                              normalizedColumn
                            ) ||

                            normalizedColumn.includes(
                              normalizedKey
                            )
                          );
                        });

                    value =
                      row[matchedKey];
                  }
                  if (column.options?.length) {

                        const option =
                          column.options.find(
                            o =>
                              String(o.value) ===
                              String(value)
                          );

                        if (option) {
                          value = option.label;
                        }
                      }
                  return (

                    <td
                      key={column.key}
                    >

                      {
                        formatValue(
                          value
                        )
                      }

                    </td>

                  );
                }
              )
                      }

                  </tr>

                );

              })
              }

          </tbody>

        </table>

      </div>
      {afterTableFields.map((field) => (

      <div
        key={field.field_key}
        className="sr-box"
        style={{ marginTop: "20px" }}
      >

    <label>
      {field.label}
    </label>

    <div className="sr-text">
      {formatValue(
        tableMeta?.[field.field_key]
      )}
    </div>

  </div>

))}
      
                {
        question.system_value && (

          <div className="sr-result">

            <span>

              {
                question.ui_schema
                  ?.summary
                  ?.label ||
                "Summary"
              }

            </span>

            <strong>

              {
                Number(
                  question.system_value
                ).toLocaleString(
                  "en-IN",
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }
                )
              }

            </strong>

          </div>

        )
      }
    </>

  );
  };

  // =====================================
  // LOADING
  // =====================================

  if (loading) {

    return (

      <div className="sr-loading">
        Loading...
      </div>

    );
  }

  // =====================================
  // NO DATA
  // =====================================

  if (!data.length) {

    return (

      <div className="sr-page">

        <div className="sr-header">

          <div>

            <h2>
              Submitted Responses —
              {" "}
              {principleCode}
            </h2>

          </div>

        </div>

        <div className="sr-card">

          <p className="no-data">
            No responses found
          </p>

        </div>

      </div>

    );
  }

  // =====================================
  // UI
  // =====================================

  return (

    <div className="sr-page">

      {/* HEADER */}

      <div className="sr-header">

        <div>

          <h2>
            Submitted Responses —
            {" "}
            {principleCode}
          </h2>

          <p>
            Read-only view of
            submitted disclosures
            for {principleCode}
          </p>
<div className="principle-meta-info">

              <div className="principle-meta-item">

                <span className="principle-meta-label">
                  Reporting Year:
                </span>

                <span className="principle-meta-value">
                  {reportingYear}
                </span>

              </div>

              <div className="principle-meta-item">

                <span className="principle-meta-label">
                  Legal Entity:
                </span>

                <span className="principle-meta-value">
                  {entityName || "N/A"}
                </span>

              </div>

            </div>
        </div>

        <div className="readonly-pill">
          🔒 Read-only
        </div>

      </div>

      {/* QUESTIONS */}

      {
        data.map((question) => (

          <div
            key={question.question_id}
            className="sr-card"
          >
<div className="ecf-indicator-type">{question.indicator_type}</div>
            {/* TOP */}

            <div className="sr-top">

              <span className="tag">
                {
                  question.question_code
                }
              </span>

             

            </div>

            {/* QUESTION */}

            <div className="ecf-section-title">

              {
                question.question_text
              }

            </div>

            {/* CONTENT */}

            {
              question.input_type ===
              "single" &&
              renderSingle(question)
            }

            {
              question.input_type ===
              "grouped" &&
              renderGrouped(question)
            }

            {
              question.input_type ===
              "derived" &&
              renderDerived(question)
            }

            {
              question.input_type ===
              "table" &&
              renderTable(question)
            }

            {/* EVIDENCE */}

            {
              renderEvidence(
                question.evidence
              )
            }

          </div>

        ))
      }
<button
            className="back_button"
            onClick={() =>
              navigate(
                "/dashboard/principle-dashboard",
                {
                  state: {
                    entityId:
                      location.state?.entityId,
                  },
                }
              )
            }
          >
            ← Back to Principals
          </button>
    </div>

  );
}